import styled from 'styled-components';

const Wrapper = styled.span`
  display: inline-flex;
`;

export default Wrapper;
